module.exports = __webpack_public_path__ + "img/btn_user_ue_active.80b7b6ea.png";